module.exports = __webpack_public_path__ + "static/media/download.8d2e21b6.svg";